<template>
  <div class="institution-card">
    <div class="logo-container">
      <el-image class="institution-logo" :src="cardData.logo" fit="cover" />
    </div>
    <div class="institution-info">
      <div class="institution-box">
        <div class="info-item">
          <el-image class="item-icon" :src="TimeIcon" />
          <label>建校时间</label>
          <span>{{ cardData.found }}</span>
        </div>
        <div class="info-item">
          <el-image class="item-icon" :src="CategoryIcon" />
          <label>办校类型</label>
          <span>{{ cardData.level }}</span>
        </div>
        <div class="info-item">
          <el-image class="item-icon" :src="SchoolIcon" />
          <label>简介</label>
          <div class="item-content">
            <span>{{ cardData.intro }}</span>
            <div class="read-more" @click="showModal = true">
              <i class="el-icon-arrow-down" />
              <div class="read-more-label">展开</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="institution-detail">
      <div class="modal-container">
        <div class="modal-header">
          <h2>学校详情</h2>
          <i class="el-icon-close close-btn" @click="showModal = false" />
        </div>
        <div class="detail-content">{{ cardData.intro }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeIcon from '@/assets/images/icons/broadcast/info-time.svg';
import CategoryIcon from '@/assets/images/icons/broadcast/info-category.svg';
import SchoolIcon from '@/assets/images/icons/broadcast/info-school.svg';

export default {
  props: {
    cardData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      TimeIcon,
      CategoryIcon,
      SchoolIcon,
      showModal: false
    };
  }
}
</script>

<style lang="less" scoped>
.institution-card {
  width: 100%;

  .logo-container {
    padding: 0.75rem;
    width: 5rem;
    height: 5rem;
    margin: 0 auto;
    border: 0.325rem solid #1F70E8;
    border-radius: 50%;
    box-shadow: 0 0 0 0.325rem #7DB1F5 inset;
    background-color: #FFFFFF;
    z-index: 2;

    .institution-logo {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .institution-info {
    margin-top: -2.5rem;
    padding: 0.325rem 0.325rem 0;
    width: 100%;
    z-index: 1;

    &::before {
      content: '';
      position: absolute;
      top: -1rem;
      left: 1rem;
      width: calc(100% - 2rem);
      height: 100%;
      border-radius: 0.875rem;
      background-color: #447DE5;
      z-index: 0;
    }
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% + 1rem);
      border-radius: 0.875rem;
      background: linear-gradient(to bottom, #277EEF, #FFFFFF 80%), linear-gradient(to right, #66D5C8, #1B66E4);
      background-repeat: no-repeat;
      background-size: 100% calc(100% - 1rem), 100% 1rem;
      background-position: left top, left bottom;
      overflow: hidden;
      z-index: 0;
    }

    .institution-box {
      padding: 1.25rem;
      padding-top: 2.75rem;
      border-radius: 0.75rem 0.75rem 0 0;
      background-color: #FFFFFF;
      z-index: 1;

      &::before {
        content: '';
        position: absolute;
        width: calc(100% - 1.5rem);
        height: calc(100% - 1.5rem);
        left: 0.75rem;
        top: 0.75rem;
        border-radius: 0.5rem;
        background: linear-gradient(to bottom, #BAD9FF, #FFFFFF 60%);
      }

      .info-item {
        margin-top: 0.5rem;
        width: 100%;
        display: flex;
        gap: 0.325rem;

        .item-icon {
          width: 1rem;
          height: 1rem;
        }
        label {
          margin-top: 1px;
          width: 3rem;
          height: 1.25rem;
          color: #1A66E4;
          font-size: 0.75rem;
          text-align: justify;
          text-justify: distribute-all-lines;

          &::after {
            content: '';
            display: none;
            display: inline-block;
            width: 100%;
          }
        }
        span, .item-content {
          flex: 1;
          font-size: 0.875rem;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .item-content {
          .read-more {
            margin-top: 0.5rem;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color: #2173EA;
            gap: 0.5rem;
          }
        }
      }
    }
  }

  .institution-detail {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.5);

    .modal-container {
      position: absolute;
      width: 100%;
      height: 70%;
      padding: 1rem;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      left: 0;
      bottom: 0;
      background-color: #FFFFFF;
      border-radius: 1.25rem 1.25rem 0 0;
      background: linear-gradient(to bottom, #E4EFFF, #FFFFFF 3.5rem);
      display: flex;
      flex-direction: column;

      .modal-header {
        padding-left: 1.5rem;
        margin-bottom: 1rem;
        width: 100%;
        height: 2rem;
        display: flex;
        align-items: center;

        h2 {
          flex: 1;
          text-align: center;
          font-size: 1rem;
        }

        .close-btn {
          width: 1.5rem;
          height: 1.5rem;
          font-size: 1.5rem;
        }
      }

      .detail-content {
        flex: 1;
        font-size: 1rem;
        color: #A0A0A0;
        overflow-y: scroll;
        text-indent: 2em;
      }
    }
  }
}
</style>
